import { ia } from 'lib/helpers/utility';

import DefaultNewCard from 'components/Patient/checkin/SecurePayment/components/PayWithCardModal/NewCard';
import SavedCards from 'components/Patient/checkin/SecurePayment/components/PayWithCardModal/SavedCards';
import { cardOptions } from 'components/Patient/checkin/SecurePayment/components/PayWithCardModal/lib/helpers';
import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';

const PayWithCardContent = ({
  cards,
  active,
  setActive,
  scrollRef,
  isFetchingNextPage,
  values,
  setErrorMessage,
  hideButton,
  buttonText,
  children,
  NewCardComponent
}) => {
  const NewCard = NewCardComponent || DefaultNewCard;

  return (
    <div className="flex flex-col gap-4">
      {ia(cards) && (
        <SegmentedControl
          active={active}
          items={cardOptions(cards)}
          onClick={(option) => setActive(option.value)}
        />
      )}
      {active === 'saved-cards' && (
        <>
          <SavedCards
            ref={scrollRef}
            cards={cards}
            isFetchingNextPage={isFetchingNextPage}
            hideButton={hideButton}
          />
          {children}
        </>
      )}
      {active === 'credit-card' && (
        <NewCard
          key="pay-with-new-card"
          onError={(error) => setErrorMessage(error)}
          recurringPayment={values?.recurringPayment}
          hideButton={hideButton}
          buttonText={buttonText}
        />
      )}
    </div>
  );
};

export default PayWithCardContent;
